import { useGeolocation } from './useGeolocation';

export interface UseDirectionsReturn {
  /**
   * Distance of the direction in meters
   */
  distance: ComputedRef<number | null>;
  /**
   * Duration of the direction in seconds
   */
  duration: ComputedRef<number | null>;
  /**
   * Coordinates of the direction
   */
  direction: ComputedRef<Coordinates[] | null>;
}

export function useDirections(
  entityCoordinates: Ref<Coordinates | null>
): UseDirectionsReturn {
  const { geolocationCoordinates, getGeolocation } = useGeolocation();

  const {
    distance,
    duration,
    coordinates: direction,
  } = useWalkingDirection(geolocationCoordinates, entityCoordinates);

  watchImmediate(entityCoordinates, newEntityCoordinates => {
    if (newEntityCoordinates) {
      getGeolocation();
    }
  });

  return {
    distance,
    duration,
    direction,
  };
}
